import { createElement } from 'react';
import { render } from 'react-dom';
import { App } from './App';
import loader from './utils/loader';
import { Configurations } from './models';

/**
 * Параметры по-умолчанию
 */
const defaultConfig: Configurations = {
  utmParams: {},
  whitelabelName: 'LT',
  disabledCopy: false,
  debug: false,
  widgetData: undefined,
  partnerKey: '0fe9fb2ff35679322db5429b18a53aee',
  redirect: '_blank',
  whitelabelLogo: undefined,
  whitelabelDomain: undefined,
  widgetName: undefined,
  isWhitelabel: false,
};

/**
 * Вызываем загрузчик и рендерим widget_loader и базовым приложением
 */
loader(window, defaultConfig, window.document.currentScript, (el, config) =>
  render(
    createElement<Configurations & { element: HTMLElement }>(App, { ...config, element: el }),
    el
  )
);
